(function () {
  var FREE_SHIPPING_THRESHOLD =
    window.drawerCartPriceConfig?.shippingFeeThreshold || 0;

  function renderCartInfo(cart) {
    var priceYen = cart.total_price / 100; // 送料は含まれない前提
    if (priceYen === 0) return;

    var totalEl = document.getElementById("cart-total-price");
    if (totalEl) totalEl.innerText = priceYen.toLocaleString() + "円";

    var noticeEl = document.getElementById("free-shipping-notice");
    if (!noticeEl) return;

    // ← ここをシンプルに
    var diff = Math.max(FREE_SHIPPING_THRESHOLD - priceYen, 0);

    if (diff === 0) {
      noticeEl.innerText = "送料無料でお届け";
    } else {
      noticeEl.innerText = "あと ¥" + diff.toLocaleString() + "で送料無料";
    }
  }

  function fetchAndRender() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then(renderCartInfo)
      .catch((err) => console.error("カート取得エラー:", err));
  }

  document.addEventListener("DOMContentLoaded", function () {
    fetchAndRender();
    ["cart:updated", "cart:build", "ajaxProduct:added"].forEach((ev) =>
      document.addEventListener(ev, fetchAndRender)
    );
  });
})();
